module.exports = __webpack_public_path__ + "static/media/corporate-services-img61.e619cddc.jpg";